import { DateFormats } from 'helpers/enums/DateTypes';
import moment from 'moment';
import React, { useMemo } from 'react';

import { clsx } from 'helpers/utils/HTMLUtils';

import translation from 'locales/translation';
import { CalendarIcon, ClockIcon } from 'plataforma-fundacao-componentes';
import styles from './styles.module.scss';

interface Props {
  date: Date;
  alignStart?: boolean;
  style?: React.CSSProperties;
}

export default function AssembleiaDateTime({ date, alignStart, style }: Props) {
  const textoDia = useMemo(() => {
    const weekdayKey =
      `weekday-${date.getDay()}` as keyof typeof translation.AssembleiaDateTime;
    const monthKey =
      `month-${date.getMonth()}` as keyof typeof translation.AssembleiaDateTime;
    const weekdayFunction = translation.AssembleiaDateTime[weekdayKey] as (
      day: number,
      month: string,
      year: number
    ) => string;

    if (typeof weekdayFunction === 'function') {
      return weekdayFunction(
        date.getDate(),
        translation.AssembleiaDateTime[monthKey] as string,
        date.getFullYear()
      );
    }

    return '';
  }, [date]);

  return (
    <time
      className={clsx([styles.root, alignStart ? styles.alignStart : ''])}
      dateTime={date.toJSON()}
      style={style}
    >
      <div className={styles.containerTime}>
        <CalendarIcon />
        <span>{textoDia}</span>
      </div>
      <div className={styles.containerTime}>
        <ClockIcon />
        <span>{moment(date).format(DateFormats.Time)}</span>
      </div>
    </time>
  );
}
